import script from "./QuemSomos.vue?vue&type=script&setup=true&lang=js"
export * from "./QuemSomos.vue?vue&type=script&setup=true&lang=js"

import "./QuemSomos.vue?vue&type=style&index=0&id=fcf52b26&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcf52b26"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QAvatar,QImg});
